import { useTranslation } from "react-i18next";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

import { Attachment } from "shared/api/api";

import Button from "features/components/Button";
import Dialog from "features/components/Dialog";
import Typography from "features/components/Typography";

interface Props {
  attachments: Attachment[];
  open: boolean;
  onClose: () => void;
  title?: string | null;
  header?: JSX.Element;
  onDownloadAttachment: (attachmentID: string) => void;
  onDownloadAll: () => void;
}

const AttachmentsModal = ({
  attachments,
  open,
  onClose,
  title,
  header,
  onDownloadAttachment,
  onDownloadAll,
}: Props) => {
  const { t } = useTranslation("common");

  return (
    <Dialog
      open={open}
      fullWidth
      onClose={onClose}
      title={header || (title ?? t("attachments.photos"))}
      showCloseIcon
      actions={
        <>
          <Button onClick={onClose} color="secondary" variant="contained">
            {t("attachments.close")}
          </Button>
          <Button onClick={onDownloadAll} color="primary" variant="contained">
            {t("attachments.download_all")}
          </Button>
        </>
      }
    >
      <div className="flex flex-col justify-center -mx-6 -mb-5">
        {attachments.map((attachment) => (
          <div
            key={attachment.ID}
            className="flex flex-row items-center gap-2 p-2 border-b justify-between px-6"
          >
            <div className="flex flex-row gap-3 items-center">
              <DescriptionOutlinedIcon />
              <Typography variant="h4">{attachment.filename}</Typography>
            </div>
            <Button
              color="primary"
              variant="text"
              size="small"
              onClick={() => onDownloadAttachment(attachment.ID)}
              endIcon={<FileDownloadOutlinedIcon />}
            >
              {t("attachments.download")}
            </Button>
          </div>
        ))}
      </div>
    </Dialog>
  );
};

export default AttachmentsModal;
